import axios from "axios"
import Logger from "js-logger"

Logger.setLevel(Logger.INFO)

var consoleHandler = Logger.createDefaultHandler()
var myHandler = function (messages, context) {
    const client = axios.create()
    const ua = window.navigator.userAgent
    const ip = ""
    const ctx = context.level.name
    const parameters = `context=${encodeURIComponent(ctx)}&userAgent=${encodeURIComponent(ua)}&message=${encodeURIComponent(messages[0])}&ip=${ip}`
    const url = `https://script.google.com/macros/s/AKfycbwZv1NdLnyrnO4TF6EJs6AR5AiI-v9h1I-lX5XLOmyM1P4dwcNE/exec?${parameters}`
    return client.get(url)
}

Logger.setHandler(function (messages, context) {
    consoleHandler(messages, context)
    myHandler(messages, context)
})

export function Log () {
    return Logger
}


// WEBPACK FOOTER //
// ./src/lib/logger.js